<template>
  <div v-if="getAppLoader" class="main main_loader">
    <Loader class="main_loader_ch" />
  </div>
  <div v-else>
    <Header></Header>
    <div class="sign_up_page">
      <div class="container">
        <div class="row align-items-center">
          <div class="col-lg-6 order-2 order-lg-1">
            <div class="sign_up_box">
              <h1>{{ $t("auth.signin.title") }}</h1>
              <template v-if="prod == 'production'">
                <a href="#" class="google_btn" @click.prevent="googleAuth">
                  <span>{{ $t("auth.signin.continue_google") }}</span>
                </a>
              </template>
              <div
                id="appleid-signin"
                data-color="black"
                data-border="true"
                data-type="sign in"
              ></div>
              <hr />
              <div class="input_box">
                <div class="label">{{ $t("auth.signin.email") }}</div>
                <input
                  type="email"
                  :placeholder="$t('auth.signin.email_placeholder')"
                  v-model="email"
                />
              </div>
              <div v-if="show_password" class="input_box">
                <div class="label">{{ $t("auth.signin.password") }}</div>
                <input
                  type="text"
                  :placeholder="$t('auth.signin.password_placeholder')"
                  v-model="password"
                />
                <img
                  :src="require('@/assets/static/images/auth/pass_show.svg')"
                  alt=""
                  @click="show_password = false"
                />
              </div>
              <div v-else class="input_box">
                <div class="label">{{ $t("auth.signin.password") }}</div>
                <input
                  type="password"
                  :placeholder="$t('auth.signin.password_placeholder')"
                  v-model="password"
                />
                <img
                  :src="require('@/assets/static/images/auth/pass_hide.svg')"
                  alt=""
                  @click="show_password = true"
                />
              </div>
              <div v-if="error" class="error_msg">{{ error }}</div>
              <div class="auth-button" :class="button_disabled ? 'active' : ''">
                <a href="#" class="button" @click.prevent="login">{{
                  $t("auth.signin.button")
                }}</a>
                <div class="image-pre-loader image-pre-loader-red"></div>
              </div>
              <a href="/auth/password/" class="forgot">{{
                $t("auth.signin.forgot_password")
              }}</a>
              <p class="small">
                {{ $t("auth.signin.agree") }}
                <a
                  href="https://taskpal.com/terms-of-service"
                  target="_blank"
                  >{{ $t("auth.signin.terms") }}</a
                >
                {{ $t("auth.signin.and") }}
                <a href="https://taskpal.com/privacy-policy" target="_blank">{{
                  $t("auth.signin.privacy")
                }}</a>
                .
              </p>
              <hr />
              <p class="text-center small">
                {{ $t("auth.signin.no_account") }}
                <router-link to="/signup">{{
                  $t("auth.signin.signup")
                }}</router-link>
              </p>
            </div>
          </div>
          <div class="col-lg-6 order-1 order-lg-2">
            <div class="sign_up_img">
              <img
                :src="require('@/assets/static/images/auth/sign.svg')"
                alt=""
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style>
#appleid-signin {
  width: 100%;
  height: 50px;
  margin-bottom: 15px;
  cursor: pointer;
}
#appleid-signin div {
  max-width: none !important;
}
</style>

<script>
import "@/assets/styles/auth/main.scss";
import { mapMutations, mapActions, mapGetters } from "vuex";
import Header from "@/components/auth/Header";

export default {
  data: () => ({
    email: "",
    password: "",
    error: "",
    show_password: false,
    appLogout: true,
    button_disabled: false,
    prod: process.env.VUE_APP_MODE,
  }),
  components: {
    Header,
  },
  computed: {
    ...mapGetters(["getAppLoader"]),
  },
  mounted() {
    this.initAppleLogin();
    document.title = "Sign In | TaskPal";
    document.querySelector("body").classList.add("intropage");
    const URLParams = new URLSearchParams(window.location.search);

    if (localStorage.getItem("login_no_data")) {
      this.error = this.$t("auth.errors.apple_login_error");
      localStorage.removeItem("login_no_data");
    }

    if (URLParams.get("app_logout")) {
      this.appLogout = true;
    } else {
      setTimeout(() => {
        this.appLogout = false;
      }, 500);
    }

    if (URLParams.get("app")) {
      localStorage.setItem("app_web_auth", 1);
    } else {
      localStorage.removeItem("app_web_auth", 1);
    }

    if (URLParams.get("app_token1") && URLParams.get("app_token2")) {
      localStorage.removeItem("app_web_auth");
      this.electronAppAuth(
        URLParams.get("app_token1"),
        URLParams.get("app_token2")
      );
    } else {
      if (!this.appLogout) {
        setTimeout(() => {
          document.querySelector(".auth .form").classList.add("show");
        }, 500);
      }

      localStorage.removeItem("w_token");
      localStorage.removeItem("w_clone_token");

      if (this.$router.history.current.query.message) {
        const routerQuery = {
          key_message: this.$router.history.current.query.message,
          message: "",
        };
        this.setMessage(routerQuery);
      }
    }

    localStorage.setItem("already_sent_firebase_key", false);
  },
  unmounted() {
    document.querySelector("body").classList.remove("intropage");
  },
  methods: {
    ...mapActions(["fetchKey"]),
    ...mapMutations(["setMessage", "onAppLoader", "offAppLoader"]),
    async initAppleLogin() {
      try {
        AppleID.auth.init({
          clientId: "com.taskpalllc.taskpal.sign",
          scope: "name email",
          redirectURI: process.env.VUE_APP_API_BASE_URL2 + "/auth",
          state: "taskpal",
          nonce: "nonce",
          usePopup: false,
        });
      } catch (error) {
        console.error("Apple Sign-In Error:", error);
      }
      document.addEventListener("AppleIDSignInOnSuccess", (event) => {
        console.log(event.detail.data);
      });
      document.addEventListener("AppleIDSignInOnFailure", (event) => {
        console.log(event.detail.error);
      });
    },
    async login() {
      if (this.button_disabled) return;

      this.error = "";

      if (!this.email) return (this.error = this.$t("auth.errors.enter_email"));
      if (!this.password)
        return (this.error = this.$t("auth.errors.enter_password"));
      if (!this.$w_email_validate(this.email))
        return (this.error = this.$t("auth.errors.email_incorrect"));

      this.button_disabled = true;

      const result = await this.fetchKey({
        url: this.$w_api.SIGN_IN,
        body: {
          email: this.email,
          password: window.btoa(this.password),
        },
      });

      if (result) {
        this.$socket.io.opts.transportOptions.polling.extraHeaders.Authorization =
          localStorage.getItem("w_token");
        this.$socket.connect();
        window.location.href = "/";
      } else {
        setTimeout(() => {
          this.button_disabled = false;
          this.error = this.$t("auth.errors.wrong_credentials");
        }, 500);
      }
    },
    electronAppAuth(token, token_clone) {
      localStorage.setItem("w_token", token);
      localStorage.setItem("w_clone_token", token_clone);
      setTimeout(() => {
        this.$router.push("/");
      }, 200);
    },
    googleAuth() {
      if (document.isElectron) {
        const link = document.createElement("a");
        link.id = "googleauthlink";
        link.target = "_blank";
        link.href = process.env.VUE_APP_API_BASE_URL2 + "/auth/google";
        document.getElementById("googleauthlink").click();
      } else {
        window.location.href =
          process.env.VUE_APP_API_BASE_URL2 + "/auth/google";
      }
    },
  },
};
</script>
